// useDroppableCategory.js - Hook for making category rows droppable using native HTML5 drag and drop
import { useCallback, useState, useContext } from 'react';
import { GanttDndContext } from '../context/GanttDndContext';

export const useDroppableCategory = (category) => {
  const [isOver, setIsOver] = useState(false);
  const { onTaskMove, isEditMode } = useContext(GanttDndContext);

  const handleDragOver = useCallback((event) => {
    // Only allow drop in edit mode
    if (!isEditMode) return;

    // Prevent default to allow drop
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  }, [isEditMode]);

  const handleDragEnter = useCallback((event) => {
    // Only show hover effect in edit mode
    if (!isEditMode) return;

    event.preventDefault();
    setIsOver(true);
  }, [isEditMode]);

  const handleDragLeave = useCallback((event) => {
    // Check if we're actually leaving the category row (not just entering a child)
    if (event.currentTarget === event.target || !event.currentTarget.contains(event.relatedTarget)) {
      setIsOver(false);
    }
  }, []);

  const handleDrop = useCallback((event) => {
    // Only allow drop in edit mode
    if (!isEditMode) return;

    event.preventDefault();
    setIsOver(false);

    try {
      const data = JSON.parse(event.dataTransfer.getData('application/json'));
      const { task, category: fromCategory } = data;

      // Only process if dropped on a different category
      if (fromCategory.id !== category.id) {
        // Call the provided onTaskMove callback if available
        if (onTaskMove) {
          onTaskMove({
            task,
            fromCategory,
            toCategory: category,
          });
        }
      }
    } catch (error) {
      console.error('Error handling drop:', error);
    }
  }, [category, onTaskMove, isEditMode]);

  return {
    isOver,
    onDragOver: handleDragOver,
    onDragEnter: handleDragEnter,
    onDragLeave: handleDragLeave,
    onDrop: handleDrop,
  };
};
